module.exports = __webpack_public_path__ + "static/media/cardJ.e29f8a34.svg";